import script from "./partner_add.vue?vue&type=script&setup=true&lang=js"
export * from "./partner_add.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__